import React, { useEffect, useState } from "react";

import FrontendLayout from "../../layouts/FrontendLayout";
import Helmet from "../../components/Helmet";
import {  useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import api from "../../api/axiosInstance";

// import "/assets/css/login.css";
export default function Home() {
  const [finalSubmit, setFinalSubmit] = useState("");
  const formStatus = "";
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [loginData, setLoginData] = useState({});
  const [editData, seteditData] = useState({});

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    sol_roll_no: "",
    contact_number: "",
    course: "",
    admission_year: "",
    semester: "",
    aadhar_number: "",
    pan_number: "",
    bank_account_holder_name: "",
    bank_account_number: "",
    bank_ifsc_code: "",
    bank_name: "",
    father_name: "",
    father_job: "",
    father_annual_income: "",
    father_pan: "",
    father_itr: "",
    mother_name: "",
    mother_job: "",
    mother_annual_income: "",
    mother_pan: "",
    mother_itr: "",
    total_income: "",
    income_lies_between: "",
    dependent_member: "",
    income_certificate_no: "",
    income_issued_by: "",
    income_issued_date: "",
    ration_card_name: "",
    ration_card_issued_by: "",
    ration_card_issued_date: "",
    final_submit: "",
  });

  const validateField = (fieldName, fieldValue) => {
    const value = (fieldValue ?? "").toString().trim();

    const isEmpty = (v) => (v ?? "").toString().trim().length === 0;

    // Required fields in this form
    const required = new Set([
      "admission_year",
      "semester",
      "aadhar_number",
      "bank_account_number",
      "bank_ifsc_code",
      "bank_name",
      "father_name",
      "father_job",
      "father_annual_income",
      // "father_itr",
      "mother_name",
      "mother_job",
      "mother_annual_income",
      // "mother_itr",
      "total_income",
      "income_lies_between",
      "dependent_member",
      "income_certificate_no",
      "income_issued_by",
      "income_issued_date",
    ]);

    if (required.has(fieldName) && isEmpty(value))
      return "This field is required";

    switch (fieldName) {
      case "sol_roll_no":
      case "name":
      case "course":
      case "father_name":
      case "mother_name":
      case "bank_account_holder_name":
        return "";

      case "aadhar_number":
        return /^\d{12}$/.test(value) ? "" : "Aadhaar must be 12 digits";

      case "pan_number":
      case "father_pan":
      case "mother_pan":
        if (!value || value.trim() === "") {
          return "";
        }

        return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)
          ? ""
          : "Invalid PAN (example: ABCDE1234F)";

      case "bank_name":
        return /^[a-zA-Z0-9\s&.,-]{2,50}$/.test(value)
          ? ""
          : "Bank name must be 2-50 characters";

      case "bank_account_number":
        return /^\d{9,18}$/.test(value)
          ? ""
          : "Bank account number must be 9 to 18 digits";

      case "bank_ifsc_code":
        return /^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)
          ? ""
          : "Invalid IFSC Code (example: HDFC0123456)";

      case "father_job":
      case "mother_job":
        return /^[a-zA-Z,\s]{2,50}$/.test(value)
          ? ""
          : "Job type must be 2-50 characters (letters, spaces, commas)";

      case "father_annual_income":
      case "mother_annual_income":
      case "total_income":
        if (!/^[\d,]+$/.test(value)) return "Only numbers and commas allowed";
        const incomeNum = Number(value.replace(/,/g, ""));
        if (Number.isNaN(incomeNum) || incomeNum < 0)
          return "Enter a valid income amount";
        return "";

      case "father_itr":
      case "mother_itr":
        if (!value || value.trim() === "") {
          return "";
        }

        const itrValue = value.trim();

        return /^[0-9,]+$/.test(itrValue)
          ? ""
          : "ITR must contain only numbers and commas";

      case "income_lies_between":
        return /^(Below 4 Lakh|Between 4 Lakh to 8 Lakh|Above 8 Lakh)$/.test(
          value,
        )
          ? ""
          : "Select a valid income range";

      case "dependent_member":
        if (!/^\d+$/.test(value)) return "Dependent member must be a number";
        const depNum = Number(value);
        if (depNum < 1 || depNum > 20)
          return "Dependent members must be between 1 and 20";
        return "";

      case "income_issued_date": {
        if (!value || value.trim() === "") {
          return "Select a valid date";
        }

        if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
          return "Select a valid date";
        }

        const date = new Date(value);
        if (isNaN(date.getTime())) {
          return "Select a valid date";
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (date > today) {
          return "Date cannot be in the future";
        }

        const minDate = new Date("2026-04-01");
        if (date < minDate) {
          return "Date cannot be before 01 April 2026";
        }

        return "";
      }

      case "ration_card_issued_date": {
        if (!value || value.trim() === "") {
          return "";
        }

        if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
          return "Select a valid date";
        }

        const date = new Date(value);
        if (isNaN(date.getTime())) {
          return "Select a valid date";
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (date > today) {
          return "Date cannot be in the future";
        }

        return "";
      }

      default:
        return "";
    }
  };

  const validateForm = (data) => {
    const nextErrors = {};
    Object.keys(data).forEach((k) => {
      const err = validateField(k, data[k]);
      if (err) nextErrors[k] = err;
    });
    return nextErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let filteredValue = value;

    switch (name) {
      case "bank_account_number":
      case "aadhar_number":
      case "dependent_member":
        filteredValue = value.replace(/[^0-9]/g, "");
        break;
      case "bank_ifsc_code":
        filteredValue = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
        break;
      case "total_income":
      case "father_annual_income":
      case "mother_annual_income":
      case "father_itr":
      case "mother_itr":
        filteredValue = value.replace(/[^0-9,]/g, "");
        break;

      case "bank_name":
        filteredValue = value.replace(/[^a-zA-Z0-9\s&.,-]/g, "").toUpperCase();
        break;

      case "ration_card_name":
        filteredValue = value.replace(/[^a-zA-Z.\s]/g, "").toUpperCase();
        break;

      case "father_job":
      case "mother_job":
        filteredValue = value.replace(/[^a-zA-Z,\s]/g, "").toUpperCase();
        break;

      case "father_pan":
      case "mother_pan":
      case "pan_number":
        filteredValue = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
        break;

      // case "marks_percentage":
      //   filteredValue = value.replace(/[^0-9.]/g, "");
      //   break;

      case "income_certificate_no":
        filteredValue = value.replace(/[^a-zA-Z0-9/\s-]/g, "").toUpperCase();
        break;

      case "income_issued_by":
      case "ration_card_issued_by":
        filteredValue = value.replace(/[^a-zA-Z0-9\s.,-]/g, "").toUpperCase();
        break;

      default:
        filteredValue = value;
    }

    const error = validateField(name, filteredValue);
    setFormData((prev) => ({ ...prev, [name]: filteredValue }));
    setErrors((prev) => {
      // Remove error as soon as the field becomes valid
      if (!error) {
        const next = { ...prev };
        delete next[name];
        return next;
      }
      return { ...prev, [name]: error };
    });
  };

  useEffect(() => {
    if (editData) {
      setFormData((prev) => ({
        ...prev,
        name: editData.STUDENT_NAME || prev.name,
        sol_roll_no: editData.SOL_ROLL_NO || prev.sol_roll_no,
        contact_number: editData.MOBILE || prev.contact_number,
        course: editData.COURSE || prev.course,
        admission_year: editData.ADMISSION_YEAR || prev.admission_year,
        semester: editData.SEMESTER || prev.semester,
        aadhar_number: editData.STUDENT_ADHAR_NO || prev.aadhar_number,
        pan_number: editData.STUDENT_PAN_NO || prev.pan_number,
        bank_account_holder_name:
          editData.BANK_HOLDER_NAME || prev.bank_account_holder_name,
        bank_account_number:
          editData.STUDENT_BANK_ACC || prev.bank_account_number,
        bank_ifsc_code: editData.BANK_IFSC_CODE || prev.bank_ifsc_code,
        bank_name: editData.STUDENT_BANK_NAME || prev.bank_name,
        father_name: editData.FATHER_NAME || prev.father_name,
        father_job: editData.FATHER_TYPE_OF_JOB || prev.father_job,
        father_annual_income:
          editData.FATHER_ANNUAL_INCOME || prev.father_annual_income,
        father_pan: editData.FATHER_PAN_NO || prev.father_pan,
        father_itr: editData.FATHER_ITR || prev.father_itr,
        mother_name: editData.MOTHER_NAME || prev.mother_name,
        mother_job: editData.MOTHER_TYPE_OF_JOB || prev.mother_job,
        mother_annual_income:
          editData.MOTHER_ANNUAL_INCOME || prev.mother_annual_income,
        mother_pan: editData.MOTHER_PAN_NO || prev.mother_pan,
        mother_itr: editData.MOTHER_ITR || prev.mother_itr,
        total_income: editData.TOTAL_FAMILY_INCOME || prev.total_income,
        income_lies_between:
          editData.INCOME_LIES_BETWEEN || prev.income_lies_between,
        dependent_member: editData.DEPENDENT_MEMBER || prev.dependent_member,
        // marks_percentage: editData.PERCENTAGE_MARKS || prev.marks_percentage,
        income_certificate_no:
          editData.INCOME_CERTIFICATE_NO || prev.income_certificate_no,
        income_issued_by: editData.INCOME_ISSUED_BY || prev.income_issued_by,
        income_issued_date:
          (editData?.INCOME_ISSUE_DATE &&
          !isNaN(new Date(editData.INCOME_ISSUE_DATE))
            ? new Date(editData.INCOME_ISSUE_DATE).toISOString().split("T")[0]
            : prev.income_issued_date) || "",
        ration_card_name: editData.RATION_CARD_NAME || prev.ration_card_name,
        ration_card_issued_by:
          editData.RATION_ISSUED_BY || prev.ration_card_issued_by,
        ration_card_issued_date:
          (editData?.RATION_ISSUE_DATE &&
          !isNaN(new Date(editData.RATION_ISSUE_DATE))
            ? new Date(editData.RATION_ISSUE_DATE).toISOString().split("T")[0]
            : prev.ration_card_issued_date) || "",
      }));
    }
  }, [editData]);

  useEffect(() => {
    const fetchLoginData = async () => {
      try {
        const res = await api.get("/fetchLoginData");
        setLoginData(res.data.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchLoginData();
  }, []);

  useEffect(() => {
    if (loginData && Object.keys(loginData).length > 0) {
      setFormData((prevData) => ({
        ...prevData,
        name: loginData.STUDENT_NAME || prevData.name,
        sol_roll_no: loginData.SOL_ROLL_NO || prevData.sol_roll_no,
        course: loginData.COURSE || prevData.course,
        contact_number: loginData.MOBILE || prevData.contact_number,
        admission_year: loginData.ADMISSION_YEAR || prevData.admission_year,
        semester: loginData.SEMESTER || prevData.semester,
        // marks_percentage: loginData.OVERALL_MARKS || prevData.marks_percentage,
        father_name: loginData.FATHER_NAME || prevData.father_name,
        mother_name: loginData.MOTHER_NAME || prevData.mother_name,
      }));
    }
  }, [loginData]);

  useEffect(() => {
    const fetchPreviewData = async () => {
      setLoading(true);
      try {
        const res = await api.get("/fetchPreviewData");
        seteditData(res.data.data);
        setFinalSubmit(res.data.data.FINAL_SUBMIT);
      } catch (error) {
        console.error("Error fetching preview data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPreviewData();
  }, []);

  useEffect(() => {
    if (finalSubmit === '1') {
      navigate("/completed");
    }

    if (formStatus === '1') {
      navigate("/preview");
    }
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm(formData);
    setErrors(validationErrors);

    toast.error(Object.keys(validationErrors));

    if (Object.keys(validationErrors).length > 0) {
      const firstErrorKey = Object.keys(validationErrors)[0];
      toast.error(validationErrors[firstErrorKey]);
      return;
    }

    try {
      setLoading(true);

      await api.post("/save", formData);

      const sol_roll_no = formData.sol_roll_no;

      toast.success("Saved successfully");

      setTimeout(() => {
        navigate("/preview", {
          state: { sol_roll_no },
        });
      }, 1500);
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet title="Personal" />
      <FrontendLayout />
      <div className="main">
        <ToastContainer position="top-center" autoClose={3000} />
        {loading ? (
          <div className="full-page-loader">
            <ClipLoader size={60} />
          </div>
        ) : (
          <section
            className="container-fluid px-0 py-4"
            style={{ width: "95%" }}
          >
            <div className="col-12">
              <h4 className="mb-4 text-primary text-center fw-bold">
                FINANCIAL SUPPORT SCHEME (FSS) 2026-27
              </h4>
              <form className="card shadow p-4" onSubmit={handleSubmit}>
                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="name"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Student's Name
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className={`form-control ${
                        errors.name ? "is-invalid" : ""
                      }`}
                      value={formData.name}
                      onChange={handleChange}
                      disabled
                    />
                    {errors.name && (
                      <div className="invalid-feedback">{errors.name}</div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="sol_roll_no"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      SOL Roll No.
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="sol_roll_no"
                      name="sol_roll_no"
                      className={`form-control ${
                        errors.sol_roll_no ? "is-invalid" : ""
                      }`}
                      value={formData.sol_roll_no}
                      onChange={handleChange}
                      readOnly
                    />
                    {errors.sol_roll_no && (
                      <div className="invalid-feedback">
                        {errors.sol_roll_no}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="contact_number"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Contact No.
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="contact_number"
                      name="contact_number"
                      className={`form-control ${
                        errors.contact_number ? "is-invalid" : ""
                      }`}
                      value={formData.contact_number}
                      onChange={handleChange}
                      disabled
                    />
                    {errors.contact_number && (
                      <div className="invalid-feedback">
                        {errors.contact_number}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="sol_roll_no"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Programme
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="course"
                      name="course"
                      className={`form-control ${
                        errors.course ? "is-invalid" : ""
                      }`}
                      value={formData.course}
                      onChange={handleChange}
                      disabled
                    />
                    {errors.course && (
                      <div className="invalid-feedback">{errors.course}</div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="admission_year"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Admission Year
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.admission_year ? "is-invalid" : ""
                      }`}
                      name="admission_year"
                      value={formData.admission_year || ""}
                      disabled
                      readOnly
                    />

                    {errors.admission_year && (
                      <div className="invalid-feedback">
                        {errors.admission_year}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="semester"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Current semester
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      className={`form-control ${
                        errors.semester ? "is-invalid" : ""
                      }`}
                      name="semester"
                      readOnly
                      value={formData.semester}
                      onChange={handleChange}
                    />
                    {errors.semester && (
                      <div className="invalid-feedback">{errors.semester}</div>
                    )}
                  </div>
                </div>

                {/* <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="marks_percentage"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Overall Marks ( Percentage )
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="marks_percentage"
                      name="marks_percentage"
                      className={`form-control ${
                        errors.marks_percentage ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.marks_percentage}
                      placeholder="Enter Total Percentage"
                      readOnly
                    />
                    {errors.marks_percentage && (
                      <div className="invalid-feedback">
                        {errors.marks_percentage}
                      </div>
                    )}
                  </div>
                </div> */}

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="aadhar_number"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Aadhaar Number <span className="text-danger">*</span>
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="aadhar_number"
                      name="aadhar_number"
                      className={`form-control ${
                        errors.aadhar_number ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.aadhar_number}
                      placeholder="Enter Your Aadhaar Number"
                      required
                    />
                    {errors.aadhar_number && (
                      <div className="invalid-feedback">
                        {errors.aadhar_number}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="pan_number"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      PAN Number
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="pan_number"
                      name="pan_number"
                      className={`form-control ${
                        errors.pan_number ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.pan_number}
                      placeholder="Enter Your PAN Number"
                    />
                    {errors.pan_number && (
                      <div className="invalid-feedback">
                        {errors.pan_number}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="bank_account_holder_name"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Bank Account Holder Name
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="bank_account_holder_name"
                      name="bank_account_holder_name"
                      className={`form-control ${
                        errors.bank_account_holder_name ? "is-invalid" : ""
                      }`}
                      value={formData.name}
                      placeholder="Enter Bank Account Holder Name"
                      readOnly
                    />
                    {errors.bank_account_holder_name && (
                      <div className="invalid-feedback">
                        {errors.bank_account_holder_name}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="bank_account_number"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Bank Account Number (Aadhaar Verified){" "}
                      <span className="text-danger">*</span>
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="bank_account_number"
                      name="bank_account_number"
                      className={`form-control ${
                        errors.bank_account_number ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.bank_account_number}
                      placeholder="Enter Bank Account Number"
                      required
                    />
                    {errors.bank_account_number && (
                      <div className="invalid-feedback">
                        {errors.bank_account_number}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="bank_ifsc_code"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Bank IFSC Code <span className="text-danger">*</span>
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="bank_ifsc_code"
                      name="bank_ifsc_code"
                      className={`form-control ${
                        errors.bank_ifsc_code ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.bank_ifsc_code}
                      placeholder="Enter Bank IFSC Code"
                      required
                    />
                    {errors.bank_ifsc_code && (
                      <div className="invalid-feedback">
                        {errors.bank_ifsc_code}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="bank_name"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Bank Name <span className="text-danger">*</span>
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="bank_name"
                      name="bank_name"
                      className={`form-control ${
                        errors.bank_name ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.bank_name}
                      placeholder="Enter Bank Name"
                      required
                    />
                    {errors.bank_name && (
                      <div className="invalid-feedback">{errors.bank_name}</div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="father_name"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Father's Name
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="father_name"
                      name="father_name"
                      className={`form-control ${
                        errors.father_name ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.father_name}
                      placeholder="Enter Father's Name"
                      readOnly
                    />
                    {errors.father_name && (
                      <div className="invalid-feedback">
                        {errors.father_name}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="father_job"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Father's Occupation <span className="text-danger">*</span>
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="father_job"
                      name="father_job"
                      className="form-control"
                      onChange={handleChange}
                      value={formData.father_job}
                      placeholder="Enter Father's Occupation"
                      required
                    />
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="father_annual_income"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Father's Annual Income
                      <span className="text-danger">*</span>
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="father_annual_income"
                      name="father_annual_income"
                      className={`form-control ${
                        errors.father_annual_income ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.father_annual_income}
                      placeholder="Enter Father's Annual Income"
                      required
                    />
                    {errors.father_annual_income && (
                      <div className="invalid-feedback">
                        {errors.father_annual_income}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="father_pan"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Father's PAN No.
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="father_pan"
                      name="father_pan"
                      className={`form-control ${
                        errors.father_pan ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.father_pan}
                      placeholder="Enter Father's PAN No."
                      maxLength={10}
                    />
                    {errors.father_pan && (
                      <div className="invalid-feedback">
                        {errors.father_pan}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="father_itr"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Father's ITR Value
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="father_itr"
                      name="father_itr"
                      className={`form-control ${
                        errors.father_itr ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.father_itr}
                      placeholder="Enter Father's ITR"
                    />
                    {errors.father_itr && (
                      <div className="invalid-feedback">
                        {errors.father_itr}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="mother_name"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Mother's Name
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="mother_name"
                      name="mother_name"
                      className={`form-control ${
                        errors.mother_name ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.mother_name}
                      placeholder="Enter Mother's Name"
                      readOnly
                    />
                    {errors.mother_name && (
                      <div className="invalid-feedback">
                        {errors.mother_name}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="mother_job"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Mother's Occupation <span className="text-danger">*</span>
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="mother_job"
                      name="mother_job"
                      className="form-control"
                      onChange={handleChange}
                      value={formData.mother_job}
                      placeholder="Enter Mother's Occupation"
                      required
                    />
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="mother_annual_income"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Mother's Annual Income
                      <span className="text-danger">*</span>
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="mother_annual_income"
                      name="mother_annual_income"
                      className={`form-control ${
                        errors.mother_annual_income ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.mother_annual_income}
                      placeholder="Enter Mother's Annual Income"
                      required
                    />
                    {errors.mother_annual_income && (
                      <div className="invalid-feedback">
                        {errors.mother_annual_income}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="mother_pan"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Mother's PAN No.
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="mother_pan"
                      name="mother_pan"
                      className={`form-control ${
                        errors.mother_pan ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.mother_pan}
                      placeholder="Enter Mother's PAN No."
                      maxLength={10}
                    />
                    {errors.mother_pan && (
                      <div className="invalid-feedback">
                        {errors.mother_pan}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="mother_itr"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Mother's ITR Value
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="mother_itr"
                      name="mother_itr"
                      className={`form-control ${
                        errors.mother_itr ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.mother_itr}
                      placeholder="Enter Mother's ITR"
                    />
                    {errors.mother_itr && (
                      <div className="invalid-feedback">
                        {errors.mother_itr}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="total_income"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Total Annual Family Income
                      <span className="text-danger">*</span>
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="total_income"
                      name="total_income"
                      className={`form-control ${
                        errors.total_income ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.total_income}
                      placeholder="Enter Total Annual Family Income"
                      required
                    />
                    {errors.total_income && (
                      <div className="invalid-feedback">
                        {errors.total_income}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="income_lies_between"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Total Annual Family Income Lies Between
                      <span className="text-danger">*</span>
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <select
                      className={`form-control ${
                        errors.income_lies_between ? "is-invalid" : ""
                      }`}
                      name="income_lies_between"
                      required
                      onChange={handleChange}
                      value={formData.income_lies_between}
                    >
                      <option value="">Select</option>
                      <option value="Below 4 Lakh">Below 4 Lakh</option>
                      <option value="Between 4 Lakh to 8 Lakh">
                        Between 4 Lakh to 8 Lakh
                      </option>
                      <option value="Above 8 Lakh">Above 8 Lakh</option>
                    </select>
                    {errors.income_lies_between && (
                      <div className="invalid-feedback">
                        {errors.income_lies_between}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="dependent_member"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      No. of Dependent family Members
                      <span className="text-danger">*</span>
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="dependent_member"
                      name="dependent_member"
                      className={`form-control ${
                        errors.dependent_member ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.dependent_member}
                      placeholder="Enter No. of Dependent family Members"
                      required
                    />
                    {errors.dependent_member && (
                      <div className="invalid-feedback">
                        {errors.dependent_member}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="income_certificate_no"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Income Certificate No.{" "}
                      <span className="text-danger">*</span>
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="income_certificate_no"
                      name="income_certificate_no"
                      className="form-control"
                      onChange={handleChange}
                      value={formData.income_certificate_no}
                      placeholder="Enter Income certificate No."
                      required
                    />
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="income_issued_by"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Income Certificate Issued By{" "}
                      <span className="text-danger">*</span>
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="income_issued_by"
                      name="income_issued_by"
                      className="form-control"
                      onChange={handleChange}
                      value={formData.income_issued_by}
                      placeholder="Enter Income certificate Issued by"
                      required
                    />
                  </div>
                  {errors.income_issued_by && (
                    <div className="invalid-feedback">
                      {errors.income_issued_by}
                    </div>
                  )}
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="income_issued_date"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Income Certificate Issued Date{" "}
                      <span className="text-danger">*</span>
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="date"
                      id="income_issued_date"
                      name="income_issued_date"
                      className={`form-control ${
                        errors.income_issued_date ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.income_issued_date}
                      required
                    />
                    {errors.income_issued_date && (
                      <div className="invalid-feedback">
                        {errors.income_issued_date}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="ration_card_name"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Ration Card Name
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="ration_card_name"
                      name="ration_card_name"
                      className="form-control"
                      onChange={handleChange}
                      value={formData.ration_card_name}
                      placeholder="Enter Ration Card Name"
                    />
                  </div>
                  {errors.ration_card_name && (
                    <div className="invalid-feedback">
                      {errors.ration_card_name}
                    </div>
                  )}
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="ration_card_issued_by"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Ration Card Issued By
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="text"
                      id="ration_card_issued_by"
                      name="ration_card_issued_by"
                      className={`form-control ${
                        errors.ration_card_issued_by ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.ration_card_issued_by}
                      placeholder="Enter Ration Card Issued by"
                    />
                    {errors.ration_card_issued_by && (
                      <div className="invalid-feedback">
                        {errors.ration_card_name}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <div className="col-md-3 form-label-col">
                    <label
                      htmlFor="ration_card_issued_date"
                      className="form-label fw-semibold mb-0 text-center text-md-end"
                    >
                      Ration Card Issued Date
                    </label>
                  </div>

                  <div className="col-md-5 ps-0">
                    <input
                      type="date"
                      id="ration_card_issued_date"
                      name="ration_card_issued_date"
                      className={`form-control ${
                        errors.ration_card_issued_date ? "is-invalid" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.ration_card_issued_date}
                    />
                    {errors.ration_card_issued_date && (
                      <div className="invalid-feedback">
                        {errors.ration_card_issued_date}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row justify-content-center align-items-end mb-4 g-0">
                  <button
                    type="submit"
                    className="btn btn-primary px-5"
                    disabled={loading}
                    style={{ width: "50%" }}
                  >
                    {loading ? "Saving..." : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </section>
        )}
      </div>
    </>
  );
}
